import { render, staticRenderFns } from "./RiskOrgnManage_VerHistory.vue?vue&type=template&id=5ccd20c6&scoped=true&"
import script from "./RiskOrgnManage_VerHistory.vue?vue&type=script&lang=js&"
export * from "./RiskOrgnManage_VerHistory.vue?vue&type=script&lang=js&"
import style0 from "./RiskOrgnManage_VerHistory.vue?vue&type=style&index=0&id=5ccd20c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccd20c6",
  null
  
)

export default component.exports